import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { collection, onSnapshot, query } from '@firebase/firestore';
import { Unsubscribe } from '@firebase/util';
import { Subject } from 'rxjs';
import { LoadingService } from '../loading.service';
import { BlogPost } from './blog-post';
import { AngularFireStorage } from '@angular/fire/compat/storage';

@Injectable({
  providedIn: 'root'
})
export class BlogService {

  constructor(public firestore: AngularFirestore, public loadingService: LoadingService, private storage: AngularFireStorage,) { this.getBlogPosts() }
  
  keepFocus = false
  addingNewBlogPost = false
  selectedBlogPost?: BlogPost
  db = this.firestore.firestore
  blogPostListener?: Unsubscribe
  private allBlogPosts = new Subject<any>();
  public allBlogPosts$ = this.allBlogPosts.asObservable();
  
  getBlogPosts() {
    if (this.blogPostListener != null) {
      return
    }

    const q = query(collection(this.db, "blog"));
    this.blogPostListener = onSnapshot(q, (querySnapshot) => {
      const snapshotBlogPosts: BlogPost[] = []
      querySnapshot.forEach((doc) => {
        const data = doc.data()
        const uid = doc.id
        const title = data["title"]
        const content = data["content"]
        const date = data["date"]
        const author = data["author"]

        const blogPost = { uid, title, content, date, author } as BlogPost
        snapshotBlogPosts.push(blogPost)
      });
      snapshotBlogPosts.sort((a, b) => a.date < b.date ? -1 : 1);
      this.allBlogPosts.next(snapshotBlogPosts)
    },
      (error) => {
        alert(error)
        throw(error)
      });;
    }

  
  addBlogPostCancelled() {
    this.addingNewBlogPost = false
    this.keepFocus = false
  }

  async addNewBlogPost(blogPost: BlogPost, loadingKey: string, file?: File) {
    const newBlogPostDoc = this.db.collection("blog").doc();
    var blogPostToPost = Object(blogPost)

    delete blogPostToPost.uid

    if (file != null && file != undefined) {
        const fileExtension = this.returnFileType(file.name)
        const fileName = `${blogPost.title}.${fileExtension}`
        const fileNameEncoded = fileName.replace(/ /g, '_');
        const filePath = `blogPostPhotos/${fileNameEncoded}`;
        const ref = this.storage.ref(filePath);
        await ref.put(file);
        blogPostToPost["picFileName"] = fileNameEncoded
    }

    newBlogPostDoc.set(blogPostToPost)
    .then(response => {
      this.keepFocus = false
      this.loadingService.removeLoadingKey(loadingKey)
      this.addingNewBlogPost = false
      this.selectedBlogPost = undefined
      alert("BlogPost added successfully")
    })
    .catch(e => {
      this.loadingService.removeLoadingKey(loadingKey)
      alert(e)
      throw(e)
    });
  }

  async updateBlogPost(blogPost: BlogPost, newfile?: File) {
    const loadingKey = blogPost.uid!!
    this.loadingService.addLoadingKey(loadingKey)
    const blogPostDoc = this.db.collection("blog").doc(blogPost.uid);
    
    var blogPostToPost = Object(blogPost)
    delete blogPostToPost.uid

    if (newfile != null && newfile != undefined) {
        const fileExtension = this.returnFileType(newfile.name)
        const titleEncoded = blogPost.title.replace(/[^a-z0-9]/gi, '_').toLowerCase();
        const fileName = `${titleEncoded}.${fileExtension}`
        const fileNameEncoded = fileName.replace(/ /g, '_');
        const filePath = `blogPostPhotos/${fileNameEncoded}`;
        const ref = this.storage.ref(filePath);
        await ref.put(newfile);
        blogPostToPost["picFileName"] = fileNameEncoded
    }

    blogPostDoc.update(blogPostToPost)
    .then(response => {
      this.keepFocus = false
      this.loadingService.removeLoadingKey(loadingKey)
      this.addingNewBlogPost = false
      this.selectedBlogPost = undefined
      alert("BlogPost Updated successfully")
    })
    .catch(e => {
      this.loadingService.removeLoadingKey(loadingKey)
      alert(e)
      throw(e)
    });
  }

  async deleteBlogPost(blogPost: BlogPost) {
    const loadingKey = blogPost.title
    this.loadingService.addLoadingKey(loadingKey)
    const blogPostDoc = this.db.collection("blog").doc(blogPost.uid);
    
    blogPostDoc.delete()
    .then(response => {
      this.keepFocus = false
      this.loadingService.removeLoadingKey(loadingKey)
      this.addingNewBlogPost = false
      this.selectedBlogPost = undefined
      alert("BlogPost Removed successfully")
    })
    .catch(e => {
      this.loadingService.removeLoadingKey(loadingKey)
      alert(e)
      throw(e)
    });
  }

  returnFileType(fileName: string) {
    return fileName.split('.').pop();
  }

  //FIXME: - fire this - add all listeners to a user repository array? then end all active on sign out.
  signout() {
    if (this.blogPostListener != null) {
      this.blogPostListener()
    }
  }
}
